module.exports = __webpack_public_path__ + "img/ErsterWeihnachtsbaum.bf4a0275.jpg";